import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const pillars = [
  ["SOURCE", "/source", "pillar-card-source", "Explore Indian sourcing opportunities shaped around your category, specification and destination market."],
  ["CONNECT", "/connect", "pillar-card-connect", "Share your buying requirements and begin relevant trade conversations with UGI."],
  ["FACILITATE", "/facilitate", "pillar-card-facilitate", "Coordinate requirements, documentation and next steps with greater clarity."],
  ["EXPAND", "/expand", "pillar-card-expand", "Evaluate routes into GCC, African and wider global markets as opportunities emerge."],
];

export default function FourPillars() {
  return (
    <section data-testid="ugi-pillars-section" className="mx-auto max-w-7xl px-5 py-20 sm:px-8 lg:py-28">
      <div className="mb-12 grid gap-8 lg:grid-cols-[0.8fr_1.2fr]">
        <p className="text-sm font-bold uppercase tracking-[0.3em] text-[#C5A059]">How UGI Works</p>
        <h2 className="max-w-3xl font-serif text-3xl font-normal leading-tight tracking-[-0.02em] text-[#1C1613] sm:text-4xl">
          A clear trade pathway for buyers entering India-linked corridors.
        </h2>
      </div>
      <div className="grid border-l border-t border-[#E5DFD3] sm:grid-cols-2 lg:grid-cols-4">
        {pillars.map(([title, href, testId, copy], index) => (
          <Link to={href} data-testid={testId} key={title} className="group min-h-[280px] border-b border-r border-[#E5DFD3] bg-[#FDFBF7] p-7 transition-colors hover:bg-[#F5F2EB] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#C5A059]">
            <div className="mb-14 flex items-start justify-between">
              <span className="font-serif text-5xl font-light text-[#C5A059]/50">0{index + 1}</span>
              <ArrowUpRight size={18} strokeWidth={1.5} className="text-[#C5A059] transition-transform group-hover:-translate-y-1 group-hover:translate-x-1" />
            </div>
            <h3 className="text-sm font-bold tracking-[0.22em] text-[#1C1613]">{title}</h3>
            <p className="mt-5 text-sm leading-7 text-[#524842]">{copy}</p>
          </Link>
        ))}
      </div>
    </section>
  );
}
